<div class="page-center-wrapper">

    <div class="card-header wp-header">

        <div class="row wp-image-text">
            <div class="wp-image-text-image" style="text-align: center;">
                <img class="img-fluid mx-auto d-block" src="../assets/images/ACI-Horizontal-White.png" style="height:30%">                 
            </div>
        </div>

    </div>

    <div class="card-body wp-body">

        <div class="add-title">
            <h4 class="text-center">{{title}}</h4>
            <h5 class="text-center">{{subtitle}}</h5>
        </div>

        <form [formGroup]="pswResetForm">

            <!-- username -->

            <div class="row">
                <div class="col-12">
                    <div class="form-group row mt-0 mb-0">

                        <label for="userName" class="col-form-label col-form-label-sm">
                            USERNAME
                        </label>
            
                        <div class="col-sm-8">
                            <input formControlName="userName" id="userName" type="text"
                                class="form-control form-control-sm border border-primary" placeholder="Username"/>
                        </div>

                        @if (!pswResetForm.get('userName')?.valid && pswResetForm.get('userName')?.dirty) {
                            <div class="alert alert-danger">
                                Username is required
                            </div>
                        }

                    </div>

                </div>

            </div> 

            <!-- new password -->

            <div class="row">
                <div class="col-12">
                    <div class="form-group row mt-0 mb-0">

                        <label for="newPassword" class="col-form-label col-form-label-sm">
                            NEW PASSWORD
                        </label>
            
                        <div class="col-sm-8 password-container">
                            <input formControlName="newPassword" id="newPassword" 
                                type="{{ isPasswordShown ? 'text' : 'password' }}"
                                class="form-control form-control-sm border border-primary" placeholder="New User Password"/>
                            <button type="button" class="wp-btn-submit" (click)="togglePasswordVisibility()">
                              {{ isPasswordShown ? 'Hide' : 'Show' }}
                            </button>
                        </div>

                        @if (!pswResetForm.get('newPassword')?.valid && pswResetForm.get('newPassword')?.dirty) {
                            <div class="alert alert-danger">
                                New password is required
                            </div>
                        }

                    </div>

                </div>

            </div> 

            <!-- confirm password -->

            <div class="row">
                <div class="col-12">
                    <div class="form-group row mt-0 mb-0">

                        <label for="confirmPassword" class="col-form-label col-form-label-sm">
                            CONFIRM PASSWORD
                        </label>
            
                        <div class="col-sm-8">
                            <input formControlName="confirmPassword" id="confirmPassword" 
                                type="{{ isPasswordShown ? 'text' : 'password' }}"
                                class="form-control form-control-sm border border-primary" placeholder="Confirm New Password"/>
                        </div>

                        @if (!pswResetForm.get('confirmPassword')?.valid && pswResetForm.get('confirmPassword')?.dirty) {
                            <div class="alert alert-danger">
                                Confirm password is required
                            </div>
                        }

                    </div>

                </div>

            </div> 

            <div class="row">
                <div class="col-6 text-center">
                    @if (isSubmitButtonShown) {
                        <button type="submit" icon="fa fa-check" class="wp-btn-submit" (click)="onSubmit()" 
                            [disabled]="!pswResetForm.valid">Submit
                        </button>
                    }
                </div>
            </div>

        </form>

        @if (isSuccessMessageShown) {
            <div class="alert alert-success" role="alert">{{successMessage}}</div>
        }
        @if (isErrorMessageShown) {
            <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
        }

    </div>

    <div class="card-footer" style="background-color: transparent;">


    </div>

</div>


